import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Action = {
    _v1: {
        createOrderWithVariable: { method: HttpMethod.POST, path: '/v1/create-order-with-variable' },
    }
};
//# sourceMappingURL=api-def.js.map